import "./App.css";

import "./i18n/index";
import {
  Link,
  Route,
  BrowserRouter as Router,
  Switch,
  Redirect,
  RouteComponentProps,
  RouteProps,
  
} from "react-router-dom";

import Home from "./pages/home/Home";
import Navbar from "./components/navbar/Navbar";
import FootView from "./components/foot/FootView";
import Search from "./pages/home/components/Search";
import Details from "./components/details/Details";
import Adviser from "./pages/about/adviser/Adviser";
import TinkTank from "./pages/about/tinktank/TinkTank";
import JoinUs from "./pages/about/joinus/JoinUs";
import Contact from "./pages/about/contact/Contact";
import LinkUs from "./pages/about/linkus/LinkUs";
import Report from "./pages/activity/Report";
import Member from "./pages/member/Member";
import Policy from "./pages/policy/Policy";
import News from "./pages/news/News";
import Media from "./pages/news/Media";
import Login from "./pages/login/Login";
import Outlook from './pages/outlook/Outlook';

interface IProps extends RouteProps {
  component: React.ComponentType<RouteComponentProps>;
  authed?: Boolean;
}

function App() {
  const RouteItem: React.FC<IProps> = ({ component: Component, ...rest }) => {
    return (
      <Route
        render={(props: any) => {
          return (
            <>
              <Navbar />
              <Component {...props} />
              <FootView index={props.match.path === "/index"} />
            </>
          );
        }}
        {...rest}
      />
    );
  };

  return (
    // <Router forceRefresh={true}>
    //   <Switch>
    //     <Route exact path="/">
    //       <Redirect to="/index" />
    //     </Route>
        
    //     <Route path={"/login"} component={Login} />

    //     <RouteItem path="/index" component={Home} />
    //     <RouteItem path="/search" component={Search} />
    //     <RouteItem path="/details" component={Details} />
    //     <RouteItem path="/newsroom/press-release/date_pressreleasetitle_tc" component={Details} />

    //     <RouteItem path="/adviser" component={Adviser} />

    //     <RouteItem path="/joinus" component={JoinUs} />
    //     <RouteItem path="/contact" component={Contact} />
    //     <RouteItem path="/linkus" component={LinkUs} />
    //     <RouteItem path="/outlook" component={Outlook} />
    //     <RouteItem path="/outlook#" component={Outlook} />
        

    //     <RouteItem path="/report" component={Report} />
    //     <RouteItem path="/member" component={Member} />
    //     <RouteItem path="/book" component={Policy} />
    //     <RouteItem path="/review" component={Policy} />
    //     <RouteItem path="/newsroom/press-releases"  component={News} >
         
    //     </RouteItem>
    //     <RouteItem path="/media" component={Media} />
    //   </Switch>
    // </Router>

    <Router forceRefresh={true}>
      <Switch>
        <Route exact path="/index">
          <Redirect to="//" />
        </Route>

        <Route exact path="/tinktank" >
        <Redirect to="/about-us/member" />  
        </Route> 

        <Route exact path="/member" >
        <Redirect to="/commentary" />  
        </Route> 

        <Route exact path="/report" >
        <Redirect to="/whats_on_neg" />  
        </Route> 

        <Route exact path="/media" >
        <Redirect to="/newsroom/media_coverage" />  
        </Route> 

        <Route exact path="/book" >
        <Redirect to="/policy-research/journals-published" />  
        </Route> 

        <Route exact path="/contact" >
        <Redirect to="/about-us/contact-us" />  
        </Route> 



        {/* ----------------------------------------------------------------- */}
        <Route path={"/login"} component={Login} />
        <RouteItem path="//" component={Home} />
        <RouteItem path="/index" component={Home} />
        <RouteItem path="/search" component={Search} />
        <RouteItem path="/details" component={Details} />
        <RouteItem path="/newsroom/press-release/date_pressreleasetitle_tc/:id" component={Details} />
        <RouteItem path="/newsroom/press-release/date_pressreleasetitle_tc" component={Details} />

        <RouteItem path="/newsroom/press-release/date_activity/:id" component={Details} />
        <RouteItem path="/newsroom/press-release/date_activity" component={Details} />
        <RouteItem path="/commentary/member_date_comment/:id" component={Details} />
        <RouteItem path="/commentary/member_date_comment" component={Details} />

        <RouteItem path="/about-us/mission&convener_statement/:id" component={Outlook} />
        <RouteItem path="/about-us/mission&convener_statement" component={Outlook} />
        <RouteItem path="/about-us/advisory_board" component={Adviser} />
        <RouteItem path="/about-us/member" component={TinkTank} />
        <RouteItem path="/about-us/join-us" component={JoinUs} />
        <RouteItem path="/about-us/contact-us" component={Contact} />
        <RouteItem path="/about-us/related_links" component={LinkUs} />

        <RouteItem path="/whats_on_neg" component={Report} />

        <RouteItem path="/commentary" component={Member} />
        <RouteItem path="/book" component={Policy} />
        <RouteItem path="/review" component={Policy} />

        <RouteItem path="/policy-research/journals-published" component={Policy} />
        <RouteItem path="/policy-research/article-reviews" component={Policy} />

        <RouteItem path="/newsroom/press-releases"  component={News} />
        <RouteItem path="/newsroom/media_coverage" component={Media} />
      </Switch>
    </Router>
  );
}

export default App;